import Core from "./Core"
import Client from "./Client"
import List from "./List"

const Store = {
  namespaced: true,
  modules: {
    Core,
    Client,
    List
  }
}

export default Store
